import { z } from 'zod'
import { VoucherSchema } from '../Accounting/Voucher/validation'

export const PurchaseInvoiceRowSchema = z.object({
	id: z.number(),
	purchaseInvoiceId: z.number(),
	account: z.number(),
	info: z.string(),
	total: z.string(),
	costCentreId: z.number(),
	vat: z.number(),
	realPrice: z.string(),
	databaseSource: z.string(),
})

export const PurchaseInvoiceSchema = z.object({
	id: z.number(),
	state: z.number(),
	date: z.string(),
	info: z.string(),
	invoiceNum: z.string(),
	invoiceDate: z.string(),
	delivNum: z.number(),
	total: z.string(),
	paymTerm: z.number(),
	dueDate: z.string(),
	supplierId: z.number(),
	suppCname: z.string(),
	referenceNumber: z.string(),
	referenceNote: z.string(),
	accountNumber: z.string(),
	iban: z.string(),
	bic: z.string(),
	currency: z.string(),
	vat: z.string(),
	purchaseOrders: z.string(),
	purchasingAcc: z.number(),
	realPrice: z.string(),
	realVat: z.string(),
	databaseSource: z.string(),
	voucher: VoucherSchema.nullish(),
	purchaseInvoiceRows: z.array(PurchaseInvoiceRowSchema),
})
